import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';

import { AuthenticationService } from '../../../services/authentication.service';
import { DynamicMenuService } from '../../../services/dynamic-menu.service';
import { StyleBuilder } from '../../../services/style-builder';
import { menuComponentFromTo, MenuModelFromTo } from '../../../Models/menuComponentFromTo';
import { AdminService } from '../../../services/admin.service';

@Component({
  selector: 'app-login',
  templateUrl: 'Login.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  submitClick = false;
  submitted = false;
  error = '';
  menuComponent: MenuModelFromTo[] = menuComponentFromTo;
  authenticationObj = {
    username: '',
    password: ''
  };
  get catchError(): string {
    if (this.error) {
      return this.error;
    } else {
      return this.styleBuilder.errorMessage;
    }
  }

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private menu: DynamicMenuService,
    private styleBuilder: StyleBuilder,
    private adminService: AdminService) { }

  ngOnInit() {

    document.title = 'Login';

    this.loginForm = new FormGroup({
      username: new FormControl(this.authenticationObj.username, [
        Validators.required
      ]),
      password: new FormControl(this.authenticationObj.password, [
        Validators.required
      ]),
    });

    // reset login status
    this.authenticationService.logout();

  }

  // convenience getter for easy access to form fields
  get formData() { return this.loginForm.controls; }

  onLogin() {
    this.submitted = true;
    this.submitClick = true;
    this.error = '';

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      this.submitClick = false;
      return;
    }


    this.authenticationService.login(this.formData.username.value, this.formData.password.value)
      .pipe(first())
      .subscribe(
        data => {
          if (data.isTempPassword) {
            if (data.hasSecurityQuiz) {
              this.router.navigate(['/updateSecurityQuestions'],
                { state: { username: this.formData.username.value, isAnswer: false, token: data.token } });
            } else {
              this.router.navigate(['/changeTempPassword'],
                { state: { changeTempPassLogin: this.formData.username.value } });
            }
          } else {
            this.authenticationService.getMenus.subscribe(r => {
              if (r) {
                localStorage.setItem('navMenu', JSON.stringify(r));
                if (localStorage.getItem('navMenu')) {
                  this.menu.setRouteMenu(JSON.parse(localStorage.getItem('navMenu')));
                  this.navigateToFavPage();
                }
              }
            });
          }
        },
        error1 => {
          this.error = error1;
          this.submitClick = false;
        });
  }

  navigateToFavPage() {
    const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.adminService.getUserFavoritePage().subscribe(
      result => {
        if (returnUrl !== '/' || !result || result.url === null || result.url === '') {
          this.router.navigate([returnUrl]);
        } else {
          const url = this.menuComponent.find(m => m.urlMenu === result.url);
          if (url !== undefined) {
            localStorage.setItem('favPage', `/${url.routeMenu}`);
            this.router.navigate([`/${url.routeMenu}`]);
          }
        }
      }
    );
  }
}
